module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/General/Thunder-move-0aa3b442b6429fb5449297142a8df8ba.svg";